import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0.5rem 1rem 0 1rem;
`;
